<template>
  <ul id="breadcrumb">
    <v-breadcrumbs-item to="/mailings"><v-icon>mdi-mail</v-icon></v-breadcrumbs-item>
    <v-breadcrumbs-item  v-for="(breadcrumb, idx) in breadcrumbs" :key="idx" :to="breadcrumb.href" :disabled="breadcrumb.disabled">{{ breadcrumb.text }}</v-breadcrumbs-item>
  </ul>
</template>

<script>
  import { mapGetters } from 'vuex'

export default {
  name: 'Breadcrumbs',
  data() {
    return {
      breadcrumbs: [],
      // ...mapState(['prevBreadcrumbs'])
    }
  },
  computed: {
    ...mapGetters(['prevBreadcrumbs']),
  },

  watch: {
    '$route' (to, from) {
      this.breadcrumbs = this.buildBreadcrumbs(to, from)
    }
  },
  mounted() {
    this.breadcrumbs = this.buildBreadcrumbs(this.$route)
  },
  methods: {
    buildBreadcrumbs(to, from=null) {
      // console.log('to: ', to, ', from:', from)
      let breadcrumbs = []
      switch (to.name) {
        case 'contact.extended_search':
          this.$store.commit('setPrevBreadcrumbs', [
            { text: to.params.title && to.params.title != '-' ? to.params.title : `[${this.$t('EXTSEARCH_TITLE')}]`, disabled: false, href: '/search/'+to.params.search_id+'/'+encodeURIComponent(to.params.title) },
            { text: this.$t('RESULTS_CONTACTS'), disabled: false, href: to.fullPath }
          ])
          breadcrumbs = [...this.prevBreadcrumbs]
          break
          
        case 'contact.search_all':
          this.$store.commit('setPrevBreadcrumbs', [
            { text: to.params.title && to.params.title != '-' ? to.params.title : `[${this.$t('EXTSEARCH_TITLE')}]`, disabled: true, href: '/search/'+to.params.search_id+'/'+encodeURIComponent(to.params.title) },
            { text: this.$t('RESULTS_CONTACTS'), disabled: false, href: to.fullPath }
          ])
          breadcrumbs = [...this.prevBreadcrumbs]
          break

        case 'contact.simple_search':
          this.$store.commit('setPrevBreadcrumbs', [
            // the "[Simple search]" item in the breadcrumbs should not be clickable because there is no search to return to
            { text: to.params.title && to.params.title != '-' ? to.params.title : `[${this.$t('RESULTS_SIMPLE_SEARCH')}: ${to.params.simple_search}]`, disabled: true, href: '/search/'+'-'+'/'+encodeURIComponent(to.params.title) },
            { text: this.$t('RESULTS_CONTACTS'), disabled: false, href: to.fullPath }
          ])
          breadcrumbs = [...this.prevBreadcrumbs]
          break

        case 'mailing':
          // console.log('buildBreadcrumbs contact.edit: ', this.prevBreadcrumbs)
          if (this.prevBreadcrumbs) {
            breadcrumbs.push({ text: (to.params.title ? to.params.title : to.params.id), disabled: true, href: to.fullPath })
          } else {
            breadcrumbs.push({ text: (to.params.title ? to.params.title : to.params.id), disabled: true, href: to.fullPath })
          }
          break

        case 'contact.edit':
          // console.log('buildBreadcrumbs contact.edit: ', this.prevBreadcrumbs)
          if (this.prevBreadcrumbs) {
            breadcrumbs = [...this.prevBreadcrumbs]
            breadcrumbs.push({ text: (to.params.title ? to.params.title : to.params.contact_id), disabled: true, href: to.fullPath })
          } else {
            breadcrumbs.push({ text: (to.params.title ? to.params.title : to.params.contact_id), disabled: true, href: to.fullPath })
          }
          break

        case 'contact.mass_edit':
          // console.log('buildBreadcrumbs contact.mass_edit: ', this.prevBreadcrumbs)
          if (this.prevBreadcrumbs) {
            breadcrumbs = [...this.prevBreadcrumbs]
            breadcrumbs.push({ text: (to.params.title ? to.params.title : `${this.$t('MASSEDIT_TITLE')}`), disabled: true, href: to.fullPath })
          } else {
            breadcrumbs.push({ text: (to.params.title ? to.params.title : `${this.$t('MASSEDIT_TITLE')}`), disabled: true, href: to.fullPath })
          }
          break

        case 'contact.settings':
          // console.log('buildBreadcrumbs contact.settings: ', this.prevBreadcrumbs)
          if (this.prevBreadcrumbs) {
            breadcrumbs = [...this.prevBreadcrumbs]
            breadcrumbs.push({ text: this.$t('SETTINGS_TITLE'), disabled: true, href: to.fullPath })
          } else {
            breadcrumbs.push({ text: this.$t('SETTINGS_TITLE'), disabled: true, href: to.fullPath })
          }
          break

        case 'contact.group':
          this.$store.commit('setPrevBreadcrumbs', [
            { text: to.params.title && to.params.title != '-' ? to.params.title : `[${this.$t('EXTSEARCH_TITLE_GROUP')}]`, disabled: false, href: '/group/'+to.params.search_id+'/'+encodeURIComponent(to.params.title) },
            { text: this.$t('RESULTS_CONTACTS'), disabled: false, href: to.fullPath }
            ])
          breadcrumbs = [...this.prevBreadcrumbs]
          break

        case 'search':
          if (from && from.name == 'contact.extended_search' && to.params.id && to.params.id == from.params.search_id) {
            breadcrumbs.push({ text: from.params.title, disabled: true, href: to.fullPath })
            breadcrumbs.push({ text: this.$t('RESULTS_CONTACTS'), disabled: false, href: from.fullPath })
          } else {
            breadcrumbs.push({ text: to.params.title && to.params.title != '-' ? to.params.title : `[${this.$t('EXTSEARCH_TITLE')}]`, disabled: true, href: to.fullPath })
          }
          break

        case 'group':
          if (from && from.name == 'contact.group' && to.params.id && to.params.id == from.params.id) {
            breadcrumbs.push({ text: from.params.title, disabled: true, href: to.fullPath })
            breadcrumbs.push({ text: this.$t('RESULTS_CONTACTS'), disabled: false, href: from.fullPath })
          } else {
            breadcrumbs.push({ text: to.params.title && to.params.title != '-' ? to.params.title : `[${this.$t('EXTSEARCH_TITLE_GROUP')}]`, disabled: true, href: to.fullPath })
          }
          break
        
        case 'contact.merge':
        if (this.prevBreadcrumbs) {
          breadcrumbs = [...this.prevBreadcrumbs]
          breadcrumbs.push({ text: this.$t('MERGE_BUTTON_EXECUTE'), disabled: true, href: to.fullPath })
        } else {
          breadcrumbs.push({ text: this.$t('MERGE_BUTTON_EXECUTE'), disabled: true, href: to.fullPath })
        }
        break
      }
      return breadcrumbs
    } 
  },
}
</script>

<style lang="scss">
$default     : #339900;
$default-alt : #33990080;
$hover       : #d6ebcc;
$hover-alt   : #d6ebcc80;

#breadcrumb{
  list-style:none;
  display: inline-block;
  
  .icon{
    font-size: 14px;
  }
  
  li{
    float:left;
    a{
      color:#FFF;
      display:block;
      background: $default;
      text-decoration: none;
      position:relative;
      height: 40px;
      line-height:40px;
      padding: 0 10px 0 5px;
      text-align: center;
      margin-right: 23px;
    }
    &:nth-child(even){
      a{
        background-color: $default-alt;
        
        &:before{
          border-color:$default-alt;
          border-left-color:transparent;
         }
        &:after{
          border-left-color:$default-alt;
        }
      }
    }
    &:first-child{
      a{
        padding-left:15px;
        border-radius:4px 0 0 4px;
        &:before{
          border:none;
         }
      }
    }
    &:last-child{
      a{
        padding-right:15px;
        border-radius:0 4px 4px 0;
        &:after{
          border:none;
         }
      }
    }
    
    a{   
      &:before,
      &:after{
        content: "";
        position:absolute;
        top: 0;
        border:0 solid $default;
        border-width:20px 10px;
        width: 0;
        height: 0;
      }
      &:before{
        left:-20px;
        border-left-color:transparent;
      }
      &:after{
        left:100%;
        border-color:transparent;
        border-left-color:$default;
      }
      &:hover{
        background-color: $hover;
        
        &:before{
          border-color:$hover;
          border-left-color:transparent;
         }
        &:after{
          border-left-color:$hover;
        }
      }
      &:active{
        background-color: $hover-alt;
        
        &:before{
          border-color:$hover-alt;
          border-left-color:transparent;
         }
        &:after{
          border-left-color:$hover-alt;
        }
      }
    }
  }
  .v-icon {
    line-height: 40px;
  }
}
.v-breadcrumbs__item {
  transition: none;
}
.v-breadcrumbs__item--disabled{
  pointer-events:none;
}
</style>
